import React from 'react';
import { MarketingNav } from '@/components/marketing/MarketingNav';
import { MarketingFooter } from '@/components/marketing/MarketingFooter';
import { HeroSection } from '@/components/marketing/HeroSection';
import { FeaturesSection } from '@/components/marketing/FeaturesSection';
import { WhyLapynoSection } from '@/components/marketing/WhyLapynoSection';
import { UseCasesSection } from '@/components/marketing/UseCasesSection';
import { PricingSection } from '@/components/marketing/PricingSection';
import { SecuritySection } from '@/components/marketing/SecuritySection';
import { FinalCTASection } from '@/components/marketing/FinalCTASection';

export default function Landing() {
  return (
    <div
      className="min-h-screen bg-[#0a0a1a] text-white overflow-x-hidden selection:bg-[#4f46e5]/40"
      style={{ fontFamily: "'DM Sans', system-ui, sans-serif" }}
    >
      <MarketingNav />
      <main>
        <HeroSection />
        <FeaturesSection />
        <WhyLapynoSection />
        <UseCasesSection />
        <PricingSection />
        <SecuritySection />
        <FinalCTASection />
      </main>
      <MarketingFooter />
    </div>
  );
}
